<template lang="pug">
  v-data-table(
    :headers="headers",
    :items="items",
    :loading="loading",
    no-data-text="Нет задач для отображения",
    hide-actions)
    template(slot="items" slot-scope="props")
      td {{ props.index + 1 }}
      td {{ props.item.childFio }}
      td {{ props.item.appointmentDate }}
      td {{ props.item.dueDate }}
      td {{ props.item.status }}
      td
        a(@click="$emit('show-issue-item', props.item.id)") Просмотреть
</template>

<script>
import IssueItem from '../../IssueItem/IssueItem'
export default {
  name: 'DataTable',
  components: { IssueItem },
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: false
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    headers: {
      type: Array,
      default: () => [],
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IssueStructure/components/DataTable/DataTable.vue